export default __webpack_public_path__ + "static/media/logo.14538376.svg";